import React, { useState, useEffect } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import styles from "./stylesAdmin.module.css"
import { ReparticionGde  } from "../../types/interfaces";
import { useLoading } from "../../components/LoadingContext";

interface EditReparticionGdeModalProps {
  show: boolean;
  onHide: () => void;
  onEditItem: (item: ReparticionGde) => void;
  item: ReparticionGde;
  showNotification: (message: string, variant: "success" | "danger") => void;
}

export default function EditReparticionGdeModal({
  show,
  onHide,
  onEditItem,
  item,
  showNotification,
}: EditReparticionGdeModalProps) {
  const { setLoading } = useLoading();
  const [formData, setFormData] = useState<any>({});
  const [errors, setErrors] = useState<any>({});

    useEffect(() => {
    if (item) {

      setFormData({
        nombre: item.nombre,
      });
    }
  }, [item]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors: any = {};
    let hasErrors = false;

    const hashSymbolPattern = /#/;

    if (!formData.nombre) {
        newErrors.nombre = "Este campo es obligatorio.";
        hasErrors = true;
    } else if (formData.nombre.length < 6) {
        newErrors.nombre = "Este campo debe tener al menos 6 caracteres.";
        hasErrors = true;
    } else if (!hashSymbolPattern.test(formData.nombre)) {
        newErrors.nombre = "Este campo debe contener al menos un símbolo '#'";
        hasErrors = true;
    }

    setErrors(newErrors);
    return !hasErrors;
};

  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const transformedData = {
        nombre: formData.nombre,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/editReparticionGde/${item.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(transformedData),
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error('Failed to edit reparticion gde');
      }

      showNotification("Repartición GDE editada con éxito", "success");
      setFormData({});
      onHide();
      onEditItem({ ...item, ...transformedData });
    } catch (error) {
      showNotification("Error al editar repartición GDE", "danger");
      console.error('Error editing reparticion gde:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} className={styles.modalContainer}>
      <Form onSubmit={handleSubmit}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title>Editar Repartición GDE</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
          <FloatingLabel controlId="floatingInputNombre" label="Nombre" className="mb-3">
            <Form.Control type="text" placeholder="Nombre" name="nombre" onChange={handleInputChange} value={formData.nombre || ""} />
          </FloatingLabel>
          {errors.nombre && <div className={styles.errors}>{errors.nombre}</div>}
          </Modal.Body>
          <Modal.Footer className={styles.modalFooter}>
          <Button variant="warning" type="submit">Actualizar</Button>
          </Modal.Footer>
        </Form>
    </Modal>
  );
}
